<template>
  <div class="indexHeader">
    <a-layout-header>
        <img @click="turnPath4"  class="logo image-class" src="../assets/image/logo1.png" />
        <div class="right" >
            <!-- <a-input v-model:value="value5" placeholder="提醒管理">
                <template #addonAfter>
                <SearchOutlined   @click="onSearch"/>
                </template>
            </a-input> -->
            <div class="tipWarpper">
                <span class="search" :class="{isActive:isActive==1}" @click="turnPath2">提醒管理</span>
                <!-- <SearchOutlined class="search1"   @click="turnPath3"/> -->
                <div class="search1" :class="{isActive:isActive==0}" >
                    <img   @mouseover="mouseOver1" @mouseleave="mouseleave1" @click="turnPath3" :src="src" alt="">
                </div>
            </div>
            <div  class="wapper1" @mouseover="mouseOver" @mouseleave="mouseleave">
                <img class="avater" :src="src3" alt="">
                <span class="userName">{{userName}}</span>
                <ul class="showItem" v-show="showItem">
                    <li class="li" @click="turnPath">修改密码</li>
                    <li class="li" @click="turnPath1">退出</li>
                </ul>
            </div>
        </div>
    </a-layout-header>
  </div>
</template>

<script>
import { SearchOutlined } from "@ant-design/icons-vue";
export default {
    data(){
        return{
            showItem:false,
            value5:'',
            src:'',
            src1:require('../assets/image2/bg3.png'),
            src2:require('../assets/image2/bg1.png'),
            src3: '',
            isActive:0,
            src4: require('../assets/avater.png'),
            src5: require('../assets/avater2.png'),
            userName:localStorage.getItem('userName')?localStorage.getItem('userName'):''
        }
    },
    components:{
        SearchOutlined
    },
    mounted(){
        // this.src = this.src1
        this.src3 = this.src5
        this.$route.path.indexOf('DataList')!=-1?this.isActive=1:this.isActive=0
        if(this.isActive==0){
            this.src = this.src2
        }else{
            this.src = this.src1
        }
    },
    methods:{
        turnPath4(){
            this.$router.push('hotWord')
        },
        turnPath3(){
            this.$router.push('hotWord')
        },
        turnPath2(){
            this.$router.push('hotDataList')
        },
        mouseOver(){
            this.showItem = true
            this.src3 = this.src4
        },
        mouseleave(){
            this.showItem = false
            this.src3 = this.src5
        },
        mouseOver1(){
            this.src = this.src2
        },
        mouseleave1(){
            if(this.isActive==0){
                return
            }
            this.src = this.src1
        },
        turnPath(){
            this.$router.push('hotChangePwd')
        },
        turnPath1(){
            localStorage.clear()
            this.$router.push('hotLogin')
        }
    }
}
</script>

<style lang="less" scoped>
    .indexHeader{
        width: 100%;
        /deep/.ant-layout-header{
            padding: 0 152px;
            height: 80px;
            background-color: #000;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #fff;
        }
        .image-class {
            width: 158px;
            cursor: pointer;
        }
        .right{
            position: relative;
            height: 100%;
            cursor: pointer;
            float: right;
            display: flex;
            align-items: center;
            .tipWarpper{
                margin-right: 40px;
                height: 100%;
                color: #b3b3b3;
                text-align: right;
                display: flex;
                align-items: center;
                justify-content: end;
                .search{
                    color: #b3b3b3;
                    font-size: 20px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    margin-right: 52px;
                    &.isActive{
                        border-bottom: 2px solid #00f000;
                        color: #fff;
                    }
                    &:hover{
                        color: #fff;
                    }
                }
                .search1{
                    width: 80px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-left: 1px solid #fff;
                    border-right: 1px solid #fff;
                    &.isActive{
                        border-bottom: 2px solid #00f000;
                    }
                    img{
                        width: 30px;
                    }
                }
                .anticon-search{
                    font-size: 25px;
                    margin-left: 20px;
                    color: #D9D9D9;
                    margin-bottom: 8px;
                }
            }
            .wapper1{
                height: 100%;
                display: flex;
                align-items: center;
                position: relative;
                padding-right: 40px;
                border-right: 1px solid #fff;
                &:hover{
                     .userName {
                         color: #fff;
                     }
                }
                .userName {
                    color: #b3b3b3;
                    font-size: 20px;
                    margin-left: 13px;
                    margin-right: 5px;
                }
                .avater{
                    width: 32px;
                }
                .showItem{
                    position: absolute;
                    background-color: #fff;
                    width: 120px;
                    top: 60px;
                    left: 0;
                    box-shadow: 3px 3px 5px #888888;
                    z-index: 999;
                    padding: 10px 0px;
                    list-style: none;
                    .li{
                        font-size: 15px;
                        padding: 10px 0;
                        text-align: center;
                        line-height: initial;
                        &:hover{
                            background-color: #333;
                            color: #fff;
                        }
                        // border-bottom: 1px solid #333;
                    }
                }
            }
            
        }
       
         .title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background: black;
            height: 75px;
            width: 100vw;
           
            & > div {
            display: flex;
            flex-direction: row;
            align-items: center;
            & > span {
                color: #aaa;
                margin-left: 20px;
                margin-right: 40px;
            }
            }
        }
    }
</style>